import type { EventType, Events } from './lib/event-types';
export * from './lib/custom-types';
export * from './lib/event-types';

declare global {
    interface Window {
        dataLayer: object[];
    }
}

const pushToDataLayer = (EventData: object) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(EventData);
};

export const triggerDataLayerEvent = <T extends EventType>(
    eventType: T,
    ecommerceData: Events[T]
) => {
    const eventData = {
        event: eventType,
        ecommerce: ecommerceData,
    };

    pushToDataLayer(eventData);
};
